// extracted by mini-css-extract-plugin
export var activeFilterButton = "_la-c";
export var backButton = "_la-4";
export var backIcon = "_la-5";
export var chevronShortcut = "_la-6";
export var container = "_la-1";
export var editor = "_la-8";
export var editorWrapper = "_la-7";
export var prefix = "_la-2";
export var searchIcon = "_la-3";
export var suffix = "_la-9";
export var suffixContent = "_la-a";
export var suffixText = "_la-b";
export var wrapper = "_la-0";